module.exports = __webpack_public_path__ + "img/Puente_Istobal_MSTART_Alto_Blanco-default-front.a284449b.jpg";